<template>
  <div class="alert alert-danger ion-margin">
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "error-message",
  props: {
    message: { type: Error }
  }
};
</script>

<style scoped>
.alert {
  position: relative;
  padding: 16px;
  margin-top: 16px;
}

.alert p {
  margin: 0;
}

.alert-danger {
  color: var(--ion-color-danger);
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
